// extracted by mini-css-extract-plugin
export default {"headerLink":"Header_headerLink__aiVs-","headerTitle":"Header_headerTitle__nq-uQ"};